import { Component, OnInit } from '@angular/core';
import { AdalService } from '../adal/adal.service';
//import { DataService } from '../services/DataService';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    //providers: [DataService]
})

export class HomeComponent implements OnInit {

    public message: string;
    public values: any[];
    public userInfo: any = {};

    constructor(
        //private _dataService: DataService
        private adalService: AdalService,
    ) {
        this.userInfo = adalService.userInfo;
    }

    ngOnInit() {
        //this._dataService
        //    .GetAll()
        //    .subscribe(data => this.values = data,
        //    error => console.log(error),
        //    () => console.log('Get all complete'));
    }
}


// WEBPACK FOOTER //
// ./app/home/home.component.ts